export const setTotalBreakdownValues = (props) => {
  const { setValue, subtotal, totalTax, total } = props;
  setValue("totalWithoutTax", subtotal ?? 0, { shouldValidate: false });
  setValue("totalTax", totalTax ?? 0, { shouldValidate: false });
  setValue("totalAfterTax", total ?? 0, { shouldValidate: false });
  setValue("totalBeforeDiscount", (subtotal ?? 0) + (totalTax ?? 0), {
    shouldValidate: false,
  });
};
